/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { StarFilled, VerifiedFilled } from "../icons/icons";

import LazyAvatar from "../lazy/LazyAvatar";

interface UserCardProps {
  avatar: string | null | undefined;
  name: string;
  rating?: number;
  location?: string;
  isVerified?: boolean;
  id: string;
  onClick?: (e?: any) => void;
}

const Content = (props: UserCardProps) => {
  return (
    <Flex
      alignItems="center"
      onClick={(e: any) => (props.onClick ? props.onClick(e) : {})}
    >
      <LazyAvatar
        width={41}
        height={41}
        border="1px solid #dce2ea"
        cursor="pointer"
        src={props.avatar}
      />
      <Box cursor="pointer" ml="10px">
        <Flex alignItems="center" gap="5px">
          <Text variant="title" fontSize="md" lineHeight="20px">
            {props.name}{" "}
          </Text>
          {props.isVerified ? (
            <Icon
              w="16px"
              h="16px"
              viewBox="0 0 16 16"
              mb="2px"
              color="#171C22"
            >
              <VerifiedFilled />
            </Icon>
          ) : (
            <></>
          )}
        </Flex>
        {!props.location && !props.rating ? (
          <></>
        ) : (
          <Flex gap="5px" alignItems="center">
            {!props.rating ? (
              <></>
            ) : (
              <Icon viewBox="0 0 12 12" w="12px" h="12px" mb="2px">
                <StarFilled color="#171C22" />
              </Icon>
            )}

            {props.rating ? (
              <Text
                variant="title"
                fontSize="md"
                lineHeight="20px"
                fontWeight="400"
              >
                {props.rating.toFixed(2)}
              </Text>
            ) : (
              <></>
            )}

            <Text
              variant="subtle"
              fontSize="md"
              lineHeight="20px"
              fontWeight="400"
            >
              {props.location ?? ""}
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
  );
};

const UserCard = (props: UserCardProps) => {
  return props.onClick ? (
    <Content {...props} />
  ) : (
    <Link to={props.onClick ? "" : `/user/profile?id=${props.id}`}>
      <Content {...props} />
    </Link>
  );
};

export default UserCard;
